const childRoutes = (prop) => [
  {
    path: 'training-instructor-profile',
    name: prop + '.training_instructor_profile',
    meta: { auth: true },
    component: () => import('../pages/training-instructor-profile/List.vue')
  },
  {
    path: 'course-management',
    name: prop + '.course_management',
    meta: { auth: true },
    component: () => import('../pages/course-management/List.vue')
  },
  {
    path: 'exam-management',
    name: prop + '.exam_management',
    meta: { auth: true },
    component: () => import('../pages/exam-management/List.vue')
  },
  {
    path: 'class-routine-management',
    name: prop + '.class_routine_management',
    meta: { auth: true },
    component: () => import('../pages/class-routine-management/List.vue')
  },
  {
    path: 'class-attendance-management',
    name: prop + '.class_attendance_management',
    meta: { auth: true },
    component: () => import('../pages/class-attendance-management/List.vue')
  },
  {
    path: 'co-curricular-scheduler',
    name: prop + '.co_curricular_scheduler',
    meta: { auth: true },
    component: () => import('../pages/co-curricular-scheduler/List.vue')
  },
  {
    path: 'transcript-mark-certificate',
    name: prop + '.transcript_mark_certificate',
    meta: { auth: true },
    component: () => import('../pages/transcript-mark-certificate/List.vue')
  },
  {
    path: 'e-notification',
    name: prop + '.e_notification',
    meta: { auth: true },
    component: () => import('../pages/e-notification/List.vue')
  }
]
const routes = [{
  path: '/child-service/education-management',
  name: 'child_service.education_management',
  component: () => import('@/layouts/ChildServiceLayout.vue'),
  meta: { auth: true },
  children: childRoutes('child_service.education_management')
}]

export default routes
